// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2LVgc","filesListContainer":"PosDisputesFiles_filesListContainer__xrsVN","filesButton":"PosDisputesFiles_filesButton__1YhFB"};